import type { ColorKind, ShapeKind } from '../assets/art/ids'
import { COMBO_VOICE, type ComboVoiceId } from '../audio/catalog'
import { assertNever } from '../never'
import type { SortBy } from './colors-levels'

const SHAPE_FIRST: Record<ShapeKind, Record<ColorKind, ComboVoiceId>> = {
  circle: {
    red: 'shape.tron.do',
    yellow: 'shape.tron.vang',
    blue: 'shape.tron.xanhduong',
    green: 'shape.tron.xanhla',
  },
  square: {
    red: 'shape.vuong.do',
    yellow: 'shape.vuong.vang',
    blue: 'shape.vuong.xanhduong',
    green: 'shape.vuong.xanhla',
  },
  triangle: {
    red: 'shape.tamgiac.do',
    yellow: 'shape.tamgiac.vang',
    blue: 'shape.tamgiac.xanhduong',
    green: 'shape.tamgiac.xanhla',
  },
}

const COLOR_FIRST: Record<Exclude<ColorKind, 'green'>, Record<ShapeKind, ComboVoiceId>> = {
  red: {
    circle: 'color.do.tron',
    square: 'color.do.vuong',
    triangle: 'color.do.tamgiac',
  },
  yellow: {
    circle: 'color.vang.tron',
    square: 'color.vang.vuong',
    triangle: 'color.vang.tamgiac',
  },
  blue: {
    circle: 'color.xanhduong.tron',
    square: 'color.xanhduong.vuong',
    triangle: 'color.xanhduong.tamgiac',
  },
}

export function matchVoiceId(shape: ShapeKind, color: ColorKind, sortBy: SortBy): ComboVoiceId {
  switch (sortBy) {
    case 'shape':
      return SHAPE_FIRST[shape][color]
    case 'color':
      if (color === 'green') return SHAPE_FIRST[shape][color]
      return COLOR_FIRST[color][shape]
    default:
      return assertNever(sortBy)
  }
}

export function matchVoiceClip(shape: ShapeKind, color: ColorKind, sortBy: SortBy): string {
  return COMBO_VOICE[matchVoiceId(shape, color, sortBy)]
}
